import { I18nContextType } from '../../libs/i18n';
import { FLAT_TYPE_GENERIC, SEARCH_QUERY_GENERIC } from '../consts';
import { canonizeFlatType, getFlatTypeFromSlug } from './flatType.utils';
import { SearchType } from '../model/enums/searchType.enum';

export const slugifySearchQuery = (str: string): string => {
  str = str.replace(/^\s+|\s+$/g, '');

  // Make the string lowercase
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  const from =
    'ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;';
  const to =
    'AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------';
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  // Remove invalid chars
  str = str
    .replace(/[^a-z0-9 -]/g, '') // Collapse whitespace and replace by -
    .replace(/\s+/g, '-') // Collapse dashes
    .replace(/-+/g, '-');

  return str;
};

export const canonizeSearchQuery = (q: string): string => {
  return q.replace(/_/g, ' ').substring(isMapAreaQuery(q) ? 2 : 0);
};

const getTitleFromQueryInternal = (
  q: string,
  searchType: number,
  flatType: string,
  i18n: I18nContextType
): string => {
  if (searchType === SearchType.MAP_BOUNDS) {
    return i18n.t('search.title.mapBounds');
  }

  const flatTypeTextPlural = flatType
    ? i18n.t(`enums.flatType.${flatType}.plural`)
    : i18n.t('search.title.flatTypeGeneric');

  if (!q) {
    return i18n.t('search.title.all', {
      flatType: flatTypeTextPlural,
    });
  }

  const closed =
    searchType === SearchType.CLOSED || searchType === SearchType.MAP_AREA;
  return i18n.t(`search.title.${closed ? 'closed' : 'open'}`, {
    flatType: flatTypeTextPlural,
    query: canonizeSearchQuery(q),
  });
};

export const getTitleFromQuery = (
  q: string,
  searchType: number,
  flatType: string,
  i18n: I18nContextType
): string => {
  const title = getTitleFromQueryInternal(q, searchType, flatType, i18n);
  return title.charAt(0).toUpperCase() + title.slice(1);
};

export const extractFlatTypeFromQuery = (flatType: string): string | null => {
  return flatType === FLAT_TYPE_GENERIC
    ? null
    : canonizeFlatType(getFlatTypeFromSlug(flatType));
};

export const extractCountyCityAndZoneFromQuery = (query: string): string[] => {
  return query
    .split('--')
    .map((part) => (part === SEARCH_QUERY_GENERIC ? undefined : part));
};

const isMapAreaQuery = (q: string): boolean => {
  return q && !!RegExp(/\d_/).exec(q);
};
